import React from 'react';
import cx from 'clsx';

import Flex from '../Flex';
import style from './index.module.css';

type Props = {
  label: string | JSX.Element | undefined;
  icon: JSX.Element;
  maxWidth?: number;
  style?: React.CSSProperties;
  textHidden?: boolean;
  labelClassName?: string;
  className?: string;
};

export const LabelWithIcon: React.FC<Props> = props => {
  return (
    <Flex
      title={typeof props.label === 'string' ? props.label : ''}
      className={cx(style.container, props.className)}
      style={Object.assign(props.maxWidth ? { maxWidth: props.maxWidth } : {}, props.style)}>
      {props.icon}
      <div className={cx(props.textHidden && 'ellipsis', props.labelClassName)}>{props.label}</div>
    </Flex>
  );
};

export default LabelWithIcon;
